<!--
  O host usa `display: contents`, então cada card abaixo vira filho direto da grade da tela que
  hospeda o componente. É o que mantém os links misturados aos itens já existentes, sem seção
  própria e sem destaque.
-->
@for (link of links(); track link.id) {
  @switch (varianteEfetiva()) {
    @case ('atalho') {
      <ng-container *ngTemplateOutlet="atalho; context: { $implicit: link }"></ng-container>
    }
    @case ('servico') {
      <ng-container *ngTemplateOutlet="servico; context: { $implicit: link }"></ng-container>
    }
    @case ('lista') {
      <ng-container *ngTemplateOutlet="lista; context: { $implicit: link }"></ng-container>
    }
    @case ('noticia') {
      <ng-container *ngTemplateOutlet="noticia; context: { $implicit: link }"></ng-container>
    }
  }
}

@if (links().length) {
  <dialog class="links-dinamicos-modal" #modal (close)="fecharModal()">
    @if (linkNoModal(); as link) {
      <div class="links-dinamicos-modal-topo">
        <div>
          <h2 class="links-dinamicos-modal-titulo">{{ link.nome }}</h2>
          @if (link.descricao) {
            <p class="links-dinamicos-modal-descricao">{{ link.descricao }}</p>
          }
        </div>

        <div class="links-dinamicos-modal-acoes">
          <button type="button" class="links-dinamicos-modal-botao" (click)="abrirEmNovaAba()">
            <i-lucide name="external-link" size="16" aria-hidden="true"></i-lucide>
            Abrir em nova aba
          </button>

          <button
            type="button"
            class="links-dinamicos-modal-fechar"
            aria-label="Fechar"
            (click)="fecharModal()"
          >
            <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
          </button>
        </div>
      </div>

      @if (urlDoModal(); as endereco) {
        <iframe class="links-dinamicos-modal-quadro" [src]="endereco" [title]="link.nome"></iframe>
      }
    }
  </dialog>
}

<!-- Home: mesmo cartão do Acesso rápido -->
<ng-template #atalho let-link>
  @if (ehDownload(link)) {
    <a
      class="links-dinamicos-atalho"
      [href]="link.urlDestino"
      [attr.download]="nomeDoArquivo(link)"
      [attr.aria-label]="descricaoAcessivel(link)"
    >
      <ng-container *ngTemplateOutlet="mioloAtalho; context: { $implicit: link }"></ng-container>
    </a>
  } @else {
    <a
      class="links-dinamicos-atalho"
      [href]="link.urlDestino"
      [attr.aria-label]="descricaoAcessivel(link)"
      (click)="abrir(link, $event)"
    >
      <ng-container *ngTemplateOutlet="mioloAtalho; context: { $implicit: link }"></ng-container>
    </a>
  }
</ng-template>

<ng-template #mioloAtalho let-link>
  <span class="links-dinamicos-atalho-circulo" [style.background]="link.corIcone" aria-hidden="true">
    @if (link.icone) {
      <img class="links-dinamicos-atalho-imagem" [src]="link.icone" [alt]="link.textoAlternativo" />
    } @else {
      <i-lucide [name]="iconeDaAbertura(link.tipoAbertura)" size="22"></i-lucide>
    }
  </span>

  <span class="links-dinamicos-atalho-conteudo">
    <span class="links-dinamicos-atalho-titulo">{{ link.nome }}</span>
    <span class="links-dinamicos-atalho-descricao">{{ link.descricao }}</span>
  </span>

  <span class="links-dinamicos-atalho-ponto" [style.background]="link.corIcone" aria-hidden="true"></span>
</ng-template>

<!-- Serviços digitais e categorias: o card das listagens, vindo de cards.css -->
<ng-template #servico let-link>
  @if (ehDownload(link)) {
    <a
      class="categoria-servicos-card links-dinamicos-servico"
      [href]="link.urlDestino"
      [attr.download]="nomeDoArquivo(link)"
      [attr.aria-label]="descricaoAcessivel(link)"
      [style.--categoria-servicos-cor]="link.corIcone"
    >
      <ng-container *ngTemplateOutlet="mioloServico; context: { $implicit: link }"></ng-container>
    </a>
  } @else {
    <a
      class="categoria-servicos-card links-dinamicos-servico"
      [href]="link.urlDestino"
      [attr.aria-label]="descricaoAcessivel(link)"
      [style.--categoria-servicos-cor]="link.corIcone"
      (click)="abrir(link, $event)"
    >
      <ng-container *ngTemplateOutlet="mioloServico; context: { $implicit: link }"></ng-container>
    </a>
  }
</ng-template>

<ng-template #mioloServico let-link>
  <span
    class="categoria-servicos-card-icone links-dinamicos-servico-icone"
    [style.background]="link.corFundo"
    [style.color]="link.corIcone"
    aria-hidden="true"
  >
    @if (link.icone) {
      <img class="links-dinamicos-servico-imagem" [src]="link.icone" [alt]="link.textoAlternativo" />
    } @else {
      <i-lucide [name]="iconeDaAbertura(link.tipoAbertura)" size="24"></i-lucide>
    }
  </span>

  <div class="categoria-servicos-card-conteudo">
    <h3 class="categoria-servicos-card-titulo">{{ link.nome }}</h3>
    <p class="categoria-servicos-card-descricao">{{ link.descricao }}</p>
  </div>

  <i-lucide
    class="categoria-servicos-card-info"
    [name]="iconeDaAbertura(link.tipoAbertura)"
    size="20"
    aria-hidden="true"
  ></i-lucide>
</ng-template>

<!-- Todos os serviços: item da lista, no mesmo formato do acordeão -->
<ng-template #lista let-link>
  <li class="links-dinamicos-item">
    @if (ehDownload(link)) {
      <a
        class="links-dinamicos-item-botao"
        [href]="link.urlDestino"
        [attr.download]="nomeDoArquivo(link)"
        [attr.aria-label]="descricaoAcessivel(link)"
      >
        <ng-container *ngTemplateOutlet="mioloItem; context: { $implicit: link }"></ng-container>
      </a>
    } @else {
      <a
        class="links-dinamicos-item-botao"
        [href]="link.urlDestino"
        [attr.aria-label]="descricaoAcessivel(link)"
        (click)="abrir(link, $event)"
      >
        <ng-container *ngTemplateOutlet="mioloItem; context: { $implicit: link }"></ng-container>
      </a>
    }
  </li>
</ng-template>

<ng-template #mioloItem let-link>
  <span class="links-dinamicos-item-titulo">{{ link.nome }}</span>

  <i-lucide
    class="links-dinamicos-item-seta"
    [name]="iconeDaAbertura(link.tipoAbertura)"
    size="18"
    aria-hidden="true"
  ></i-lucide>
</ng-template>

<!-- Notícias: card com imagem em destaque -->
<ng-template #noticia let-link>
  <article class="links-dinamicos-noticia">
    <div class="links-dinamicos-noticia-imagem-wrap" [style.background]="link.corFundo">
      @if (link.imagem) {
        <img class="links-dinamicos-noticia-imagem" [src]="link.imagem" [alt]="link.textoAlternativo" />
      } @else {
        <span class="links-dinamicos-noticia-marca" [style.color]="link.corIcone" aria-hidden="true">
          <i-lucide [name]="iconeDaAbertura(link.tipoAbertura)" size="34"></i-lucide>
        </span>
      }
    </div>

    <div class="links-dinamicos-noticia-conteudo">
      <h3 class="links-dinamicos-noticia-titulo">{{ link.nome }}</h3>
      <p class="links-dinamicos-noticia-descricao">{{ link.descricao }}</p>

      @if (ehDownload(link)) {
        <a
          class="links-dinamicos-noticia-link"
          [href]="link.urlDestino"
          [attr.download]="nomeDoArquivo(link)"
          [attr.aria-label]="descricaoAcessivel(link)"
        >
          Baixar arquivo
          <i-lucide name="download" size="16" aria-hidden="true"></i-lucide>
        </a>
      } @else {
        <a
          class="links-dinamicos-noticia-link"
          [href]="link.urlDestino"
          [attr.aria-label]="descricaoAcessivel(link)"
          (click)="abrir(link, $event)"
        >
          Ler mais
          <i-lucide [name]="iconeDaAbertura(link.tipoAbertura)" size="16" aria-hidden="true"></i-lucide>
        </a>
      }
    </div>
  </article>
</ng-template>
